export const buildQuery = (params) => {
    const usp = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v === undefined || v === null || v === "") return;
        usp.append(k, String(v));
    });
    const s = usp.toString();
    return s ? `?${s}` : "";
};

export const normalize = (url, opts) => {
    const {
        method = "get",
        params = {},
        hasPaging = false,
        defaultLimit,
        staleTime = 20000,
        debounceMs = 150,
    } = opts || {};

    const endpoint = String(url || "").trim();

    // Add paging params only if explicitly enabled
    const q = { ...params };
    if (hasPaging) {
        const limit = defaultLimit ?? 100;
        if (q.limit == null) q.limit = limit;
        if (q.offset == null) q.offset = 0;
    }

    const query = buildQuery(q);
    const normalizedUrl = query
        ? `${endpoint}${endpoint.includes("?") ? "&" : "?"}${query.slice(1)}`
        : endpoint;

    const keyObj = { url: endpoint, q, method: method.toLowerCase() };
    const key = JSON.stringify(keyObj);

    return {
        endpoint,
        url: normalizedUrl,
        key,
        method: method.toLowerCase(),
        q,
        staleTime,
        debounceMs,
    };
};